import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login'
import home from '@/views/Home'
import virtualSnListView from '@/views/account/virtualSnListView'

import photoRouters from './photoRouter';
import flatRouters from './flatRouter';
import tabletRouters from './tabletRouter';
import printerRouter from './printerRouter';
import maskRouter from "./maskRouter";
import feedbackRouter from "./feedbackRouter";
import doorbellRouter from "./doorbellRouter";
import laptopRouter from "./laptopRouter";
import payRouter from "./payRouter";
import osRouter from "./osRouter";
import babyMonitorRouter from "./babyMonitorRouter";
import projectorRouter from "./projectorRouter";
import soundRouter from "./soundRouter"
import bodyRouter from "./bodyRouter"
import publicRouter from "./publicRouter"


export const asyncRouterList = [
  ...publicRouter,
  ...photoRouters,
  ...flatRouters,
  ...tabletRouters,
  ...printerRouter,
  ...maskRouter,
  ...feedbackRouter,
  ...doorbellRouter,
  ...laptopRouter,
  ...payRouter,
  ...osRouter,
  ...babyMonitorRouter,
  ...projectorRouter,
  ...soundRouter,
  ...bodyRouter
];

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: '登录',
    component: Login
  },
  {
    path: '/home',
    name: 'home',
    component: home,
    children: [
      {
        path: '/userList',
        name: 'userList',
        component: () => import('@/views/account/userList'),
        meta: {
          title: '系统用户管理'
        }
      },
      {
        path: '/roleList',
        name: 'roleList',
        component: () => import('@/views/account/roleList'),
        meta: {
          title: '角色管理'
        }
      },
      {
        path: '/rolepermission',
        name: 'rolepermission',
        component: () => import('@/views/account/rolepermission'),
        meta: {
          title: '角色权限管理'
        }
      },
      {
        path: '/menuList',
        name: 'menuList',
        component: () => import('@/views/account/menuList'),
        meta: {
          title: '菜单管理'
        }
      },
      {
        path: '/systemList',
        name: 'systemList',
        component: () => import('@/views/account/systemList'),
        meta: {
          title: '系统管理'
        }
      },
      {
        path: '/logonList',
        name: 'logonList',
        component: () => import('@/views/account/logonList'),
        meta: {
          title: '系统用户登录日志'
        }
      },
      {
        path: '/roleSystemAuth',
        name: 'roleSystemAuth',
        meta: {
          title: '角色项目系统权限'
        },
        component: () => import('@/views/account/roleSystemAuth')
      },
      {
        path: "/signalingChannel",
        name: 'signalingChannel',
        meta: {
          title: '信令通道管理'
        },
        component: () => import('@/views/account/signalingChannel')
      },
      {
        path: '/signalingCountry',
        name: 'signalingCountry',
        meta: {
          title: '信令区域管理'
        },
        component: () => import('@/views/account/signalingCountry')
      },
      {
        path: '/peerToPeerProviderRegion',
        name: 'peerToPeerProviderRegion',
        meta: {
          title: '信令供应商区域管理'
        },
        component: () => import('@/views/account/peerToPeerProviderRegion')
      },
      {
        path: '/peerToPeerUid',
        name: 'peerToPeerUid',
        meta: {
          title: 'PeerToPeerUid管理'
        },
        component: () => import('@/views/account/peerToPeerUid')
      },
      {
        path: '/updateLog',
        name: 'updateLog',
        meta: {
          title: '更新日志'
        },
        component: () => import('@/views/account/updateLog')
      },
      {
        path: '/peerToPeerUidLog',
        name: 'peerToPeerUidLog',
        meta: {
          title: 'PeerToPeerUid日志管理'
        },
        component: () => import('@/views/account/peerToPeerUidLog')
      },
      ...asyncRouterList,
      {
        path: "/uploadFileTranslation",
        name: 'uploadFileTranslation',
        meta: {
          title: '翻译'
        },
        component:() => import('@/views/account/uploadFile.vue')
      },
      {
        path: '/appTranslationItem',
        name: 'appTranslationItem',
        meta: {
          title: '翻译工具'
        },
        component:() => import('@/views/appTranslation/appTranslationItem.vue')
      },
      {
        path: '/appTranslationList',
        name: 'appTranslationList',
        meta: {
          title: '翻译详情'
        },
        component:() => import('@/views/appTranslation/appTranslationList.vue')
      },
      {
        path: '/roleBtnAuth',
        name: 'roleBtnAuth',
        meta: {
          title: '角色按钮权限'
        },
        component: () => import('@/views/account/roleBtnAuth')
      },
      {
        path: '/deviceCategories',
        name: 'deviceCategories',
        meta: {
          title: '类目'
        },
        component: () => import('@/views/account/deviceCategories')
      },
      {
        path: '/deviceBlackList',
        name: 'deviceBlackList',
        meta: {
          title: '设备黑名单'
        },
        component: () => import('@/views/blackList/deviceBlackList')
      },
      {
        path: '/settingIndex',
        name: 'settingIndex',
        meta: {
          title: ''
        },
        component:() =>import("@/views/account/settingIndex.vue")
      },
      {
        path: '/onLineDevice',
        name: 'onLineDevice',
        meta: {
          title: '导出'
        },
        component:() =>import("@/views/account/onLineDevice.vue")
      },
      {
        path: '/ApkUpgradeLog',
        name: 'ApkUpgradeLog',
        meta: {
          title: 'apk升级日志',
        },
        component:() => import('@/views/account/ApkUpgradeLog.vue')
      },
      {
        path: '/OtaUpgradeLog',
        name: 'OtaUpgradeLog',
        meta: {
          title: 'OTA升级日志',
        },
        component:() => import('@/views/account/OtaUpgradeLog.vue')
      },{
        path: '/public/deviceLifeCycle',
        name: 'deviceLifeCycle',
        meta: {
          title: '设备周期'
        },
        component:() => import('@/views/publicView/deviceLifeCycle')
      },{
        path: '/banner/bannerImageList',
        name: 'bannerImageList',
        meta: {
          title: 'banner管理'
        },
        component:() => import('@/views/banner/bannerImageList.vue')
      }
    ]
  },{
    path: "/virtualSnListView",
    name: 'virtualSnListView',
    component: virtualSnListView
  },

]


const router = new Router({
  mode: 'history',  //去除链接带#号处理
  routes: routes
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js